export function isValidUrl(value: unknown): value is string {
	try {
		return Boolean(new URL(value as string));
	} catch {
		return false;
	}
}
